import { jsx as _jsx } from "react/jsx-runtime";
import { AccountEmpty } from '../account-empty';
import { useMemo } from 'react';
export default function ComponentWeb({ onPressCta, }) {
    const props = useMemo(() => {
        return {
            callout: {
                title: 'Custody',
                message: 'Secure your digital assets with bankruptcy-remote custody.',
                ctas: [
                    {
                        variant: 'secondary',
                        label: 'Explore our custody offering',
                        onPress: onPressCta,
                        size: 'base',
                        style: { width: 'auto' },
                    },
                ],
            },
            imageUri: {
                XS: 'product-splash/custody/Base@3x.png',
                S: 'product-splash/custody/LG@2x.png',
                M: 'product-splash/custody/LG@3x.png',
                L: 'product-splash/custody/XL@2x.png',
                XL: 'product-splash/custody/XL@3x.png',
            },
            cards: [
                {
                    icon: 'Security',
                    label: 'Superior asset protection',
                    description: 'Safeguard your assets in a secure, bankruptcy-remote environment, guaranteeing continuous ownership even in the unlikely event of insolvency.',
                },
                {
                    icon: 'Insights',
                    label: 'Integrated trading and investment',
                    description: 'Access cryptocurrencies, tokenised assets and investment products while keeping your funds segregated and protected.',
                },
                {
                    icon: 'RoomService',
                    label: 'White-glove support',
                    description: 'Experience seamless, high-touch multi-channel (phone, email, dedicated chat) support with our platform.',
                },
            ],
        };
    }, [onPressCta]);
    return _jsx(AccountEmpty, Object.assign({}, props));
}
